module.exports = __webpack_public_path__ + "static/media/Chapter 4 Slide 2-3-4-5 – 2.779042cf.jpg";